var plugin_rtlignore_default = {
  "alignLeft": "bvdgv",
  "textWrapNowrap": "-eUR6",
  "alignRight": "OzOUX",
  "alignCenter": "SfWjr",
  "sizeFullWidth": "kg4hc",
  "renderedInTable": "pPSwA",
  "sizeOriginal": "rUEw0",
  "sizeContent": "_5qOmd",
  "sizeSmall": "m1PL3",
  "sizeSmallCenter": "_1g0UO",
  "flex": "Nepl4",
  "atomic": "gowNS",
  "embed": "B6D-3",
  "horizontalScrollbar": "GnF4G",
  "pluginContainerMobile": "UoYmK"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
